import React from "react";
import Modal from "~/components/modal/Modal";
import "~/css/Button.css";
/**
 * 確認モーダルのプロパティインターフェース
 */
interface ConfirmationModalProps {
  show: boolean; // モーダル表示状態
  handleClose: () => void; // キャンセル時のコールバック
  handleConfirm: () => void; // 確認時のコールバック
  title: string; // モーダルのタイトル
  body: string; // モーダルの本文
  cancelText: string; // キャンセルボタンの文字
  confirmText: string; // 確認ボタンの文字
  variant?: string; // 確認ボタンのバリアント（デフォルトは"danger"）
}

/**
 * 確認モーダルコンポーネント
 * ユーザーに確認を要求する汎用的なモーダルダイアログを提供します
 */
const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  handleClose,
  handleConfirm,
  title,
  body,
  cancelText,
  confirmText,
}) => {
  return (
    <Modal isOpen={show} onClose={handleClose} title={title} width={600} height={400}>
      <div>{body}</div>
      <div className="modal-footer">
        {cancelText && (
          <button className="button-0" onClick={handleClose}>
            {cancelText}
          </button>
        )}
        <button className="button-1" onClick={handleConfirm}>
          {confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
